<template>
  <div id="receivableItem" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-col-gutter-md justify-center">
        <div class="col-12">
          <q-space />
        </div>
        <div class="col-md-3 col-11">
          <q-select filled v-model="queryForm['receivable.customerNo']" :options="customerList"
            option-label="customerName" option-value="customerNo" emit-value map-options label="客户" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-select filled v-model="queryForm['deliveryItem.orderInfo.yarnType']" :options="yarnList"
            option-label="typeName" option-value="id" emit-value map-options label="纱支类型" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input v-model="queryForm.orderNo" label="订单编号" filled dense />
        </div>
        <div class="col-md-3 col-11">
          <q-input v-model="queryForm.noteNo" label="送货单号" filled dense />
        </div>
        <div class="col-md-3 col-11">
          <q-input filled dense v-model="queryForm['deliveryItem.orderInfo.beginTime']" label="订单开始日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm['deliveryItem.orderInfo.beginTime']" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input filled dense v-model="queryForm['deliveryItem.orderInfo.endTime']" label="订单结束日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm['deliveryItem.orderInfo.endTime']" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input filled dense v-model="queryForm['deliveryItem.deliveryNote.beginTime']" label="送货开始日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm['deliveryItem.deliveryNote.beginTime']" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input filled dense v-model="queryForm['deliveryItem.deliveryNote.endTime']" label="送货结束日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm['deliveryItem.deliveryNote.endTime']" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-select filled v-model="queryForm['deliveryItem.supplier.id']" :options="supplierList"
            option-label="supplierName" option-value="id" emit-value map-options label="加工工厂" dense clearable />
        </div>
        <div class="col-md-9 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn label="重置" type="reset" color="primary" flat class="q-ml-sm" />
        </div>
        <div class="col-12">
          <q-space />
        </div>
      </div>
    </q-form>

    <q-table ref="mytable" title="销项明细" :data="tableData.list" :columns="columns" row-key="id"
      :pagination.sync="pagination" :loading="loading" @request="request" binary-state-sort separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]">
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn round color="primary" size="xs" icon="edit" @click="handleEdit(props.rowIndex, props.row)" />
            <q-btn round color="deep-orange" size="xs" icon="delete_forever" @click="handleRemove(props.row)" />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.totalProduct).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.totalQuantity).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.total).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
        </q-tr>
      </template>
      <template v-slot:top-right>
        <q-btn color="primary" icon-right="archive" label="导出" no-caps @click="exportTable" />
      </template>
    </q-table>
  </div>
</template>

<script>
import { listAll } from "@/api/erp/customer.js";
import { list as listYarn } from "@/api/erp/yarn.js";
import { listItem, exportItem } from "@/api/erp/finance/receivable";
import { list as listSupplier } from "@/api/erp/supplier";
import numbro from "numbro";
export default {
  data() {
    return {
      numbro,
      queryForm: {},
      customerList: [],
      supplierList: [],
      yarnList: [],
      loading: false,
      pagination: {
        sortBy: "DELIVERY_DATE",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "customerName",
          align: "center",
          label: "客户名称",
          field: (row) => row.deliveryItem.customer.customerName,
        },
        {
          name: "ORDER_DATE",
          align: "center",
          label: "订单日期",
          field: (row) => row.deliveryItem.orderInfo.orderDate,
          sortable: true,
        },
        {
          name: "itemName",
          align: "center",
          label: "项目名称",
          field: "itemName",
        },
        {
          name: "spec",
          align: "center",
          label: "规格型号",
          field: "spec",
        },
        {
          name: "DELIVERY_DATE",
          align: "center",
          label: "送货日期",
          field: (row) => row.deliveryItem.deliveryNote.deliveryDate,
          sortable: true,
        },
        {
          name: "clyNo",
          align: "center",
          label: "缸号",
          field: (row) => row.deliveryItem.cylNo,
        },
        {
          name: "productWeight",
          align: "center",
          label: "投染数",
          field: (row) =>
            numbro(row.deliveryItem.productWeight || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "quantity",
          align: "center",
          label: "数量",
          field: (row) =>
            numbro(row.quantity || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "unitPrice",
          align: "center",
          label: "单价(含税)",
          field: (row) =>
            numbro(row.unitPrice || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "total",
          align: "center",
          label: "价税合计",
          field: (row) =>
            numbro(row.total || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
      tableData: {},
    };
  },
  methods: {
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        if (response.data.errorCode == "00000") {
          self.customerList = response.data.data;
        }
      });
    },
    listYarn() {
      var self = this;
      listYarn().then((response) => {
        if (response.data.errorCode == "00000") {
          self.yarnList = response.data.data;
        }
      });
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      } else {
        self.queryForm.orderBy = null;
      }
      listItem(self.queryForm).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.tableData = response.data.data;
          self.pagination.rowsNumber = self.tableData.total;
          // don't forget to update local pagination object
          self.pagination.page = page;
          self.pagination.rowsPerPage = rowsPerPage;
          self.pagination.sortBy = sortBy;
          self.pagination.descending = descending;
          // ...and turn of loading indicator
          self.loading = false;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "DELIVERY_DATE",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    exportTable() {
      exportItem(this.queryForm).then((res) => {
        if (!res) {
          this.$message.error("导出清单失败");
          return false;
        }
        const blob = new Blob([res.data]);
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob);
        //let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        //let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
        //let result = patt.exec(contentDisposition);
        // let filename = decodeURI(result[1]);
        let filename = "对账单.xlsx";
        downloadElement.style.display = "none";
        downloadElement.href = href;
        downloadElement.download = filename; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      });
    },
  },
  mounted() {
    this.listCustomer();
    this.listYarn();
    this.query();
    listSupplier().then((response) => {
      this.supplierList = response.data.data.list;
    });
  },
};
</script>

<style scoped></style>